export const MAX_GAME_TIME_ON = 85;
export const MIN_GAME_TIME = 5;
export const MAX_GAME_TIME_OFF = 90;
